import { useReducedMotion } from 'framer-motion'
import { useAccessibility } from '../context/AccessibilityContext'

/**
 * Combines the OS `prefers-reduced-motion` preference with the user's
 * explicit in-app "Reduce animations" toggle. Returns `true` if either
 * source is asking for reduced motion.
 */
export default function useReducedMotionPreference() {
  const systemPrefers = useReducedMotion()
  const { settings } = useAccessibility()
  return Boolean(systemPrefers) || Boolean(settings.reduceMotion)
}
